import Err from '@leverege/error'

import RouteUtils from './RouteUtils.js'
import { Resource, Resources } from './rsrc/index.js'

export default function BlueprintApi( api, blueprint ) {
  
  let path = null
  if ( blueprint ) {
    if ( typeof blueprint === 'string' ) {
      path = `v1/blueprint/${blueprint}`
    } else if ( blueprint.projectId && blueprint.id ) {
      path = `v1/project/${blueprint.projectId}/blueprint/${blueprint.id}`  
    } else if ( blueprint.id ) {
      path = `v1/blueprint/${blueprint.id}`
    }
  }

  if ( path == null ) {
    throw Err( 'invalid blueprint' )
  }
  const connect = api.child( path )

  function simulate( ) {
    return connect.post( 'simulate' )
  }

  return {
    get : connect.get,
    update : connect.patch,
    delete : connect.delete,
    simulate,
    attributes( ) { return RouteUtils.collection( connect, 'attribute' ) },
    resource( rsrc ) { return new Resource( connect, rsrc ) },
    resources() { return new Resources( connect ) },
  }
}
